import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Dialog } from '@modernloop/shared/components';
import { Typography } from '@mui/material';

type DiscardNoteConfirmationDialogProps = {
  onClose: () => void;
  onDiscard: () => void;
};

const DiscardNoteConfirmationDialog = ({ onClose, onDiscard }: DiscardNoteConfirmationDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open
      onClose={onClose}
      title={t('hiring-dashboard-nav:nav.sidePanel.discardNoteTitle')}
      cancelOptions={{ label: t('hiring-dashboard-nav:nav.sidePanel.keepEditing'), onClick: onClose }}
      submitOptions={{
        label: t('hiring-dashboard-nav:nav.sidePanel.discardNote'),
        onClick: onDiscard,
        isDangerous: true,
      }}
    >
      <Typography>{t('hiring-dashboard-nav:nav.sidePanel.discardNoteBody')}</Typography>
    </Dialog>
  );
};

export default DiscardNoteConfirmationDialog;
